import styled from 'styled-components';
import { renderStyledElementStyles } from '../../../../helpers';

export type StyledMenuProps = {
  open: boolean;
};

export const StyledMenu = styled.div`
  display: ${({ open }: StyledMenuProps) => (open ? 'block' : 'none')};

  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.dStyles.elements.menu)}
  ${({ theme }) =>
    renderStyledElementStyles(theme, theme.module.vStyles.elements.menu)}
`;
